import { FormControl } from '@angular/forms';

import { passengerDtoValidator } from '@sd-portal/shared/passenger';
import { FlightPassenger } from './flight-passenger.model';

export class FlightPassengerForm {
  flightPassengerId: FormControl = new FormControl(0);
  flightId: FormControl = new FormControl(0);
  passengerStatusId: FormControl = new FormControl(0);
  businessCategoryId: FormControl = new FormControl(0);
  departmentId: FormControl = new FormControl(0);
  passenger: FormControl = new FormControl('', [passengerDtoValidator]);
  isLeadPassenger: FormControl = new FormControl(false);
  isLapChild: FormControl = new FormControl(false);
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(flightPassenger?: FlightPassenger) {
    if (flightPassenger) {
      this.flightPassengerId.setValue(flightPassenger.flightPassengerId);
      this.flightId.setValue(flightPassenger.flightId);
      this.passengerStatusId.setValue(flightPassenger.passengerStatusId);
      this.businessCategoryId.setValue(flightPassenger.businessCategoryId);
      this.departmentId.setValue(flightPassenger.departmentId);
      this.passenger.setValue(flightPassenger.passenger);
      this.isLeadPassenger.setValue(flightPassenger.isLeadPassenger);
    }
  }
}
